module.exports = __webpack_public_path__ + "static/media/spinner.11f68a46.gif";


//////////////////
// WEBPACK FOOTER
// ./src/spinner.gif
// module id = 815
// module chunks = 0